import '@/scss/style.scss';
import '@e9ine/vue_components/src/filters';
import App from './App.vue';
import i18n from '@/i18n';
import jQuery from 'jquery';
import store from '../../store';
import Vue from 'vue';

const $ = jQuery;
window.$ = $;
new Vue({
    render: h => h(App),
    store,
    i18n
}).$mount('#app');
